import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRooms } from '../../actions/userActions';
import { seeListChatCategories } from '../../admin/actions/categoriesActions';
import ListRoomsView from '../../containers/ChatRooms/ListRooms/ListRooms';
import { useTokenCallback } from '../../utils/hooks/useTokenCallback';

const ListRooms = ({routes}) => {
    const dispatch = useDispatch()
    const {allRooms,roomsIBelong,myRoomsAdmin} = useSelector(state=>state.userInfo)
    const ids = new Set(myRoomsAdmin.map(post => post._id));
    const merged = [...myRoomsAdmin, ...roomsIBelong.filter(d => !ids.has(d._id))];
    //const {allRooms} = useSelector(state=>state.userInfo)
    const {listChatCategories} = useSelector(state=>state.socialCategoriesAdmin)
  
  return  <ListRoomsView routes={routes}   allMyRooms={merged} roomsIBelong={roomsIBelong} myRooms={myRoomsAdmin} rooms={allRooms} categories={listChatCategories || []}/> 
};

export default ListRooms;
